import { createRoot } from 'react-dom/client';
import './styles/index.css';
import './ui/theme.css';
import { App } from './App.js';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

createRoot(rootEl).render(<App />);

// Register the service worker for installability + offline shell.
// Production only — in dev it would cache the HMR bundle and fight Vite.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((e) => {
      console.warn('SW registration failed:', e);
    });
  });
}
